module.exports = __webpack_public_path__ + "img/iphonex.b6f00ddc.png";